import cls from 'classnames';

import useStyles from './styles';
import ImageWithTextProps from './types';
import Media from './Media';
import TextColumns from './TextColumns';

function ImageWithText({
  className,
  imageRight,
  TitleElement = 'h2',
  title,
  description,
  src,
  srcSet,
  sizes,
  alt,
  onClick,
  ytEmbedVideoUrl,
  children,
  textColumns,
}: ImageWithTextProps) {
  const classes = useStyles();

  return (
    <section
      className={cls(
        'flex',
        'justify-center',
        classes.root,
        imageRight && classes.inverseImage,
        className,
      )}
    >
      <Media
        ytEmbedVideoUrl={ytEmbedVideoUrl}
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={alt}
        onClick={onClick}
        inverse={imageRight}
      >
        {children}
      </Media>
      <div className={cls(classes.textContainer, imageRight && classes.inverseTextContainer)}>
        {title && (
          <TitleElement className={cls(classes.title, textColumns && classes.titlePadded)}>
            {title}
          </TitleElement>
        )}
        {description && <div className={cls('fs-16', classes.description)}>{description}</div>}
        {textColumns && <TextColumns items={textColumns} />}
      </div>
    </section>
  );
}

export default ImageWithText;
